<dx-popup
    width="35%"
    height="auto"
    title="Preferences"
    [showTitle]="true"
    [dragEnabled]="true"
    [resizeEnabled]="true"
    [closeOnOutsideClick]="false"
    [visible]="visible"
    (onShown)="onShown($event)"
    (onHidden)="onHidden()"
>
    <div *dxTemplate="let data of 'content'" class="preferences-content">
        <dx-form width="100%" height="100%" [labelLocation]="formLabelLocation" [colCount]="2">
            <dxi-item itemType="group" [colCount]="1">
                <dxi-item>
                    <dxo-label text="Time Zone"></dxo-label>
                    <div *dxTemplate>
                        <dx-select-box
                            placeholder="System Timezone"
                            [items]="timeZones"
                            [searchMode]="'contains'"
                            [searchEnabled]="true"
                            [(value)]="selectedTimeZoneName"
                        ></dx-select-box>
                    </div>
                </dxi-item>
                <dxi-item>
                    <dxo-label text="Rounding"></dxo-label>
                    <div *dxTemplate>
                        <dx-number-box
                            [(value)]="selectedPrecision"
                            [min]="0"
                            [max]="4"
                            [showSpinButtons]="true"
                        ></dx-number-box>
                    </div>
                </dxi-item>
                <dxi-item>
                    <dxo-label text="Themes"></dxo-label>
                    <div *dxTemplate>
                        <dx-select-box
                            displayExpr="displayText"
                            valueExpr="name"
                            [items]="themeColors"
                            [searchMode]="'contains'"
                            [searchEnabled]="true"
                            [(value)]="selectedThemeColor"
                        ></dx-select-box>
                    </div>
                </dxi-item>
                <dxi-item>
                    <dxo-label text="Auto show Top Menu when Side Menu collapsed?"></dxo-label>
                    <div *dxTemplate>
                        <dx-select-box
                            displayExpr="text"
                            valueExpr="value"
                            [items]="topMenuOptions"
                            [searchEnabled]="false"
                            [(value)]="selectedTopMenuOption"
                        ></dx-select-box>
                    </div>
                </dxi-item>
            </dxi-item>
            <dxi-item itemType="group" [colCount]="1">
                <dxi-item>
                    <dxo-label text="Main Navigation Behavior"></dxo-label>
                    <div *dxTemplate>
                        <dx-select-box
                            displayExpr="text"
                            valueExpr="value"
                            [items]="openLinksOptions"
                            [searchEnabled]="false"
                            [(value)]="selectedOpenLinks"
                        ></dx-select-box>
                    </div>
                </dxi-item>
                <dxi-item>
                    <dxo-label text="Scrollbar Mode"></dxo-label>
                    <div *dxTemplate>
                        <dx-select-box
                            displayExpr="displayText"
                            valueExpr="key"
                            [items]="scrollbarOptions"
                            [searchEnabled]="false"
                            [(value)]="selectedScrollOption"
                        ></dx-select-box>
                    </div>
                </dxi-item>
                <dxi-item>
                    <dxo-label text="Scrollbar Type"></dxo-label>
                    <div *dxTemplate>
                        <dx-select-box
                            displayExpr="displayText"
                            valueExpr="key"
                            [items]="scrollbarTypeOptions"
                            [searchEnabled]="false"
                            [(value)]="selectedScrollTypeOption"
                        ></dx-select-box>
                    </div>
                </dxi-item>
            </dxi-item>
            <dxi-item itemType="group" [colCount]="4" [colSpan]="2">
                <dxi-item
                    itemType="button"
                    horizontalAlignment="left"
                    verticalAlignment="center"
                    [buttonOptions]="{
                        type: 'default',
                        text: 'Cancel',
                        hint: 'Cancel',
                        icon: cancelButtonIcon,
                        width: 100,
                        onClick: onCancelClick
                    }"
                ></dxi-item>
                <dxi-item itemType="empty" [colSpan]="2"></dxi-item>
                <dxi-item
                    itemType="button"
                    horizontalAlignment="right"
                    verticalAlignment="center"
                    [buttonOptions]="{
                        type: 'success',
                        text: 'Apply',
                        hint: 'Save Preferences',
                        icon: saveButtonIcon,
                        width: 100,
                        onClick: onApplyClick
                    }"
                ></dxi-item>
            </dxi-item>
        </dx-form>
    </div>
</dx-popup>
